import React, { useState, useEffect } from "react";

function total(fenceType, perimeter, gate,  isSteep, isSplit,  isDemo, setTotal)
{
    // alert(isDemo);
    const post_cost_vinyl = 64.90;
    const panel_cost_vinyl = 164.20;
    const gate_cost_vinyl = 400;
    const labourFixedVinyl = 850;
    const labourPerFeetVinyl = 18;
  
    
    const post_cost_wood = 45.25;
    const panel_cost_wood = 170;
    const gate_cost_wood = 200;
    const labourFixedWood = 1050;
    const labourPerFeetWood = 17;
    
  
    const post_cost_sleek = 125;
    const panel_cost_sleek = 450;
    const gate_cost_sleek = 900;
    const labourFixedSleek = 1500;
    const labourPerFeetSleek = 27.5;
    
    const panelLength = 8;
    const disposalFixed = 200;
    const disposalPerFeet = 3;
    let sum = 0;
  
    let total_panels = perimeter/panelLength;
        total_panels = Math.ceil(total_panels);
    let total_posts = total_panels + 1;
    let total_labour = 0;
    let gate_add_on = 0;
    let removalDisposal = 0;
    let total_materials = 0;
    if(fenceType === null)
    {
      setTotal("Please select a fence style");
      return;
    }
    if(perimeter < 35)
    {
      setTotal(null);
      return;
    }
    if(fenceType === "vinyl")
    {
      total_materials = (total_panels*panel_cost_vinyl) + (total_posts*post_cost_vinyl);
      
      total_labour = labourFixedVinyl+((perimeter-35)*labourPerFeetVinyl);
      
      gate_add_on = gate*gate_cost_vinyl;
      
    }
    if(fenceType === "treated")
    {
      total_materials = 0;
      total_materials = (total_panels*panel_cost_wood) + (total_posts*post_cost_wood);
      total_labour = labourFixedWood+((perimeter-35)*labourPerFeetWood);
      gate_add_on = gate*gate_cost_wood;
    }
    if(fenceType === "sleek")
    {
      total_materials = 0;
      total_materials = (total_panels*panel_cost_sleek) + (total_posts*post_cost_sleek);
      total_labour = labourFixedSleek+((perimeter-35)*labourPerFeetSleek);
      gate_add_on = gate*gate_cost_sleek;
    }
  
    if(isSteep === true)
    {
        // console.log("this works");
      total_labour = total_labour * 1.2;
  
    }
    console.log(isDemo);
    if(isDemo === true)
    {
      console.log(disposalFixed);
      removalDisposal = (disposalFixed + (disposalPerFeet*perimeter));
      console.log(removalDisposal);
    }
  
    sum = total_materials + total_labour + gate_add_on + removalDisposal;
  
    if(isSplit === true)
    {
      sum = sum/2;
    }
    // alert(sum);
    let finalTotal = sum.toFixed(2);
    //  alert(finalTotal);

    finalTotal = finalTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    setTotal("$" + finalTotal);
    // return(
    //   <div>{finalTotal}</div>
      
    // );
    
};
export default total;